import { render, staticRenderFns } from "./lcd.vue?vue&type=template&id=a2d1c026&scoped=true"
import script from "./lcd.vue?vue&type=script&lang=js"
export * from "./lcd.vue?vue&type=script&lang=js"
import style0 from "./lcd.vue?vue&type=style&index=0&id=a2d1c026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d1c026",
  null
  
)

export default component.exports